/**
 * Simple helper method that maps ApiFilterKeys to the filter keys required to index a postgres table, usually mapped and/or defined in psql.ts.
 *
 * * Handles converting ApiFilterKeys to psql filter keys.
 */
export const getPsqlFilters = (filters: { [filterKey: string]: string[] }, map) => {
  const mappedFilters = {};
  if (filters) {
    for (const filter of Object.keys(filters)) {
      if (map[filter]) {
        Object.assign(mappedFilters, { [map[filter]]: filters[filter] });
      }
    }
  }
  return mappedFilters;
};
